// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import React from 'react';
import TransactionRellocationLog from '../shared/transaction-reallocation-log';

function TransactionLogPage () {

    return (
        <AuthenticatedPage className="atp-page atp-transaction-log-page">
            <TransactionRellocationLog transactionLog={true} />
        </AuthenticatedPage>
    );

}
TransactionLogPage.displayNAme = 'TransactionLogPage';

export default TransactionLogPage;
